
/* global TomSelect */

$.fn.defaultChosen = function() {
  var allowSingleDeselect = ($(this).data('allowSingleDeselect') === false) ? false : true;
  $(this).chosen({
    width: '100%',
    disable_search_threshold: 4,
    allow_single_deselect: allowSingleDeselect,
    search_contains: true,
    placeholder_text_single: " ",
    placeholder_text_multiple: " "
  });
};

const escapedSelectOptionStr = (text) => {
  if (typeof(text) === 'string' && text.startsWith('<em>') && text.endsWith('</em>')) {
    return '<em>' +  _.escape(text.replace(/^<em>/, '').replace(/<\/em>$/, '')) + '</em>';
  }
  else {
    return _.escape(text);
  }
};

$.fn.dynamicChosen = function() {
  var that = this;
  var chosenId = "#" + $(that).attr("id") + "_chosen";

  $(that).chosen({
    width: "100%",
    placeholder_text_multiple: " ",
    no_results_text: "Add ",
    display_selected_options: false
  });

  var addDynamicOption = function() {
    var newInputs = $(chosenId).find(".search-field input").val().split(',');
    $.each(newInputs, function(k,v) {
      var newInput = v.replace(/^\s+|\s+$/g,'');
      $(that).append($("<option>", {
        value: newInput,
        text : newInput,
        selected: "selected"
      }));
    });
    $(that).trigger("chosen:updated").trigger('change');
  };

  var removeDynamicOption = function(val) {
    if (!val || val === '') {
      return;
    }

    $(that).find("option[value='" + val.replace("'", "\\\'") + "']").remove();
    $(that).trigger("chosen:updated");
  };

  $("body").on("click", chosenId + " .no-results", addDynamicOption);
  $("body").on("keyup", chosenId + " .search-field input", function(e) {
    if (e.which == 13 && $(chosenId + ' li.no-results').length > 0) {
      addDynamicOption();
    }
  });

  $(that).on('change', function(e, params) {
    if (params && params.deselected) {
      removeDynamicOption(params.deselected);
    }
  });
};

$.fn.defaultTokenize = function() {
  var that = this;

  var setTokenUrl = function(value, text) {
    var option = $(that).find('option[value="' + value + '"]');
    var optionUrl = option.data('url');
    var optionClass = option.data('class');

    if (optionUrl) {
      if (!text.match(/^<a .*>$/)) {
        var span = $(that).parent().find('.tokens-container li[data-value="' + value + '"] span');
        const classString = optionClass ? " class='" + optionClass + "'" : '';
        const escapedText = escapedSelectOptionStr(text);
        const html = (optionUrl === '#') ? escapedText : "<a href='" + optionUrl + "' target='_blank'" + classString + ">" + escapedText + "</a>";
        span.html(html);
      }
    }
  };

  $(this).tokenize2({
    dataSource: $(this).data('ajax'),
    debounce: 100,
    delimiter: ';',
    placeholder: $(this).data('placeholder'),
    searchMinLength: $(this).data('searchMinLength') || 0,
    dropdownMaxItems: 100,
    tokensMaxItems: $(this).data('tokensMaxItems') || 0
  }).trigger('tokenize:remap');

  $(this).find('option:selected').each(function(i, option) {
    var optionElement = $(option);
    setTokenUrl(optionElement.val(), optionElement.text());
  });

  $(this).on('tokenize:select', function(container) {
    if ( $(this).prop('disabled') ) {
      return;
    }
    $(this).tokenize2().trigger('tokenize:search', [$(this).tokenize2().input.val()]);
  });

  $(this).on('tokenize:tokens:added', function(e, value, text) {
    setTokenUrl(value, text);
    $(that).trigger('change');
    $(that).parent().find('.tokenize').blur();
  });

  $(this).on('tokenize:tokens:remove', function(e, value) {
    $(that).trigger('change');
    $(that).parent().find('.tokenize').blur();
  });
};

$.fn.defaultTomSelect = function() {
  var select = this;

  if (select.get(0).tomselect) {
    return;
  }

  var setTokenUrl = function(optionElement) {
    var option = $(optionElement);
    var optionUrl = option.data('url');

    if (optionUrl) {
      var span = $(select).parent().find('.ts-control div[data-value="' + option.val() + '"]');
      var removalAnchor = $(span).find('a.remove');
      if ($(span).find('a:not(.remove)').length < 1) {
        const escapedText = escapedSelectOptionStr(option.text());
        const html = "<a href='" + optionUrl + "' target='_blank'>" + escapedText + "</a>";
        span.html(html);
        span.append(removalAnchor);
      }
    }
  };

  let plugins = [];

  if ($(select).attr('multiple') && $(select).data('maxItems') !== 1 && $(select).attr('disabled') !== 'disabled') {
    plugins = ['remove_button'];
  }
  else if ($(select).data('allowSingleDeselect') !== false) {
    plugins = ['clear_button'];
  }

  if ($(select).data('dropdownInput')) {
    plugins.push('dropdown_input');
  }

  const renderOptionOrItem = (data, _escape) => {
      let customData = data.custom_data;
      // because this code is a mess `customData` can be either a JSON encoded string or a JS object
      if (typeof customData === "string") {
        try {
          customData = JSON.parse(customData);
        } catch (e) {
          // if it isn't valid JSON, use the original string to try and prevent ourselves from breaking this more than it already is
        }
      }
      return $(`<div></div>`).data("customData", customData).html(data.text);
  };

  var ts = new TomSelect(select, {
    plugins: plugins,
    hidePlaceholder: true,
    hideSelected: true,
    highlight: false,
    preload: 'focus',
    shouldLoad: function (query) {
      // override default behavior to allow showing "No Results" message when no results
      // are found on initial empty string search
      return true;
    },
    closeAfterSelect: $(select).data('closeAfterSelect') ? true : false,
    maxItems: $(select).data('maxItems'),
    allowEmptyOption: $(select).data('allowEmptyOption') ? true : false,
    searchField: $(select).data('ajax') ? [] : ['text'],
    create: $(select).data('selectCustom') ? true : false,
    load: function (query, callback) {
      let ajaxUrl = new URL($(select).data('ajax'), 'https://example.com');

      if ($(select).data('demandPartnerPermissionIds')) {
        const demandPartnerPermissionIds = $(select).data('demandPartnerPermissionIds');
        if (Array.isArray(demandPartnerPermissionIds)) {
          demandPartnerPermissionIds.forEach(function(id) {
            ajaxUrl.searchParams.append('demand_partner_permission_ids[]', id);
          });
        } else {
          ajaxUrl.searchParams.set('demand_partner_permission_ids', demandPartnerPermissionIds);
        }
      }

      ajaxUrl.searchParams.set('search', query);
      // we can only use 50 results at a time in the select, so only ask for that many in searches endpoints
      if (
        !ajaxUrl.searchParams.has('limit') &&
        ajaxUrl.pathname.startsWith('/searches/')
      ) {
        ajaxUrl.searchParams.set('limit', 50);
      }
      // remove the protocol/hostname/port from the url if the original url is a relative url
      var finalUrlString =
        ajaxUrl.hostname === 'example.com'
          ? ajaxUrl.pathname + ajaxUrl.search
          : ajaxUrl.toString();
      fetch(finalUrlString)
        .then((response) => response.json())
        .then((json) => {
          ts.clearOptions(); // It appends results when disabling search so have to clear first
          callback(json);
        })
        .catch(() => {
          callback();
        });
    },
    render: {
      option: renderOptionOrItem,
      item: renderOptionOrItem,
      loading: function(data, escape){
        return '';
      }
    }
  });

  // For the Demand Partner Expansion feature we need to limit what options can be selected to only those that share a
  // demand partner with the object being edited
  if ($(select).data('demandPartnerPermissionsInputId')) {
    // this gets the form element used to select the current page's demand partner
    const demandPartnerPermissionsSelector = '#' + $(select).data('demandPartnerPermissionsInputId');

    const updateStateForCurrentDemandPartnerPermissions = function (demandPartnerPermissionsTomSelect) {
      const demandPartnerPermissionIds = demandPartnerPermissionsTomSelect?.getValue() || null;

      const input = $(select)
      const tomSelect = input.get(0)?.tomselect;

      // We will use the data-demand-partner-permission-ids attribute for filtering
      input.data('demandPartnerPermissionIds', demandPartnerPermissionIds);

      if (!demandPartnerPermissionIds || (Array.isArray(demandPartnerPermissionIds) && demandPartnerPermissionIds.length <= 0)) {
        tomSelect.disable();
        $(tomSelect.wrapper).data("toggle", "tooltip");
        $(tomSelect.wrapper).data("placement", "top");
        $(tomSelect.wrapper).data("container", "body");
        $(tomSelect.wrapper).attr("title", "Demand Partner required")
      } else {
        $(tomSelect.wrapper).removeData("toggle");
        $(tomSelect.wrapper).removeData("placement");
        $(tomSelect.wrapper).removeData("container");
        $(tomSelect.wrapper).removeAttr("title")
        tomSelect.enable();
      }

      input.trigger("ajax-change");
    };

    const demandPartnerPermissionsTomSelect = $(demandPartnerPermissionsSelector).get(0)?.tomselect;
    if (demandPartnerPermissionsTomSelect) {
      demandPartnerPermissionsTomSelect?.on('change', function () {
        $(select).get(0)?.tomselect?.setValue(null);
        updateStateForCurrentDemandPartnerPermissions(this);
      });
      updateStateForCurrentDemandPartnerPermissions(demandPartnerPermissionsTomSelect);
    }
  }

  ts.on('item_add', function(value, item) {
    var optionElement = $(select).find('option[value="' + value + '"]');

    if (optionElement) {
      setTokenUrl(optionElement);
    }
  });

  ts.on("blur", function () {
    //clear out the query whenever the dropdown is closed, whether just on blur, or on select
    if (ts.items.length === 0) {
      ts.addItem("", true);
    }
    if (ts.lastQuery) {
      ts.lastQuery = null;
      ts.clearOptions();
      ts.wrapper.classList.remove("preloaded"); // allow tomselect to reload the options with empty search again
    }
  });

  // trigger custom event to clear the search query whenever the ajax changes
  $(select).on("ajax-change", function () {
    ts.lastQuery = null;
    ts.wrapper.classList.remove("preloaded"); // allow tomselect to reload the options with empty search again
    ts.clearOptions();
  });

  ts.refreshItems();

  $(select).find('option:selected').each(function(i, optionElement) {
    setTokenUrl(optionElement);
  });

  /**
   * Helper function to enable or disable loading of options for the tomselect, including
   * preload with empty query string
   * @param {*} enabled 
   */
  ts.setLoadEnabled = function(enabled) {
    if (enabled) {
      ts.settings.preload = 'focus';
      ts.settings.shouldLoad = function() { return true; };
    } else {
      ts.settings.preload = false;
      ts.settings.shouldLoad = function() { return false; };
    }
  };
};

jQuery.propHooks.disabled = {
  set: function (el, value) {
    if (el.disabled !== value) {
      el.disabled = value;
      $(el).trigger('disabledChanged');
    }
  }
};

$(document).on('turbo:load', function() {
  $.each($("select[data-ajax]:not([data-tom-select])"), function(index, select){
    $(select).defaultTokenize();
  });
  $.each($("select[data-ajax][data-tom-select]"), function(index, select){
    $(select).defaultTomSelect();
  });
  $.each($("select[data-dynamic-chosen]"), function(index, select){
    $(select).dynamicChosen();
  });
  $.each($("select:not([data-ajax]):not([data-dynamic-chosen])"), function(index, select){
    $(select).defaultChosen();
  });

  $("option").on('disabledChanged', function(){
    $(this).parent("select").trigger("chosen:updated");
  });

  $("body").on("click", ".chosen-container .chosen-choices .search-choice span", function(e){
    var closeLink = $(e.target).next("a.search-choice-close");
    if(closeLink.length){
      var select = closeLink.parents(".chosen-container").prev("select.chosen-clickable");
      if(select.length) {
        var option = select.find("option").eq(closeLink.data("optionArrayIndex"));
        var url = option.data("url");
        if(url){
          window.open(url, "_blank");
        }
      }
    }
  });

  $("body").on("mouseup", ".ts-wrapper .ts-control .item a:not(.remove)", function(e) {
    var url = $(this).attr('href');

    if (url) {
      window.open($(this).attr('href'), '_blank');
    }
  });

  $("body").on("click, mousedown", ".tokenize-dropdown li a", function(e){
    var linkTarget = $(e.target);
    linkTarget.parent().click();
    return false;
  });

  $('body').on('click', '.chosen-add-all', function(e) {
    var element = $(this);
    var target = element.data('target');
    var values = element.data('values');

    if (!target || !values) {
      return;
    }

    $(target).attr('disabled', false).val(values).trigger('chosen:updated');
  });

  $('body').on('click', '.chosen-remove-all', function(e) {
    var element = $(this);
    var target = element.data('target');

    if (!target) {
      return;
    }

    $(target).val([]).attr('disabled', true).trigger('chosen:updated');
  });
});